import { BaseQueryWithValidationClass } from 'src/editor/api/queries/utils/query-with-validation-class'
import {
  fetchContactFields,
  ContactField,
} from 'src/editor/api/contact-fields-api'

class ContactFieldsQueryClass extends BaseQueryWithValidationClass<
  [],
  ContactField[]
> {
  queryFn = fetchContactFields
  getQueryKey = () => ['contactFields'] as const
  options = {
    staleTime: 1000 * 60 * 60, // one hour
  }
}

export const contactFieldsQuery = new ContactFieldsQueryClass()
